'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _TabsWrapper = require('components/Tabs/TabsWrapper/TabsWrapper');

var _TabsWrapper2 = _interopRequireDefault(_TabsWrapper);

var _Tab = require('components/Tabs/Tab/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectsTabs = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectsTabs, _Component);

  function ProjectsTabs() {
    (0, _classCallCheck3.default)(this, ProjectsTabs);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectsTabs.__proto__ || (0, _getPrototypeOf2.default)(ProjectsTabs)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectsTabs, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var t = this.context.t;


      return _react2.default.createElement(
        _TabsWrapper2.default,
        { pullRight: true, className: (0, _bind2.default)(className) },
        _react2.default.createElement(_Tab2.default, { title: t('View All'), to: '/projects/all' }),
        _react2.default.createElement(_Tab2.default, { title: t('Audio'), to: '/projects/audio' }),
        _react2.default.createElement(_Tab2.default, { title: t('Video'), to: '/projects/video' }),
        _react2.default.createElement(_Tab2.default, { title: t('Sharespaces'), to: '/projects/sharespace' })
      );
    }
  }]);
  return ProjectsTabs;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = ProjectsTabs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectsTabs/ProjectsTabs.js
// module id = 2068
// module chunks = 1